import { apiClient } from '@/lib/api-client';
import { AgreementsRequest, AgreementsResponse } from '@/types/api';

export const agreementsApi = {
    // Update architect agreements
    updateArchitectAgreements: async (architectId: string, data: AgreementsRequest): Promise<AgreementsResponse> => {
        const response = await apiClient.put(`/architects/${architectId}/agreements`, data) as { data: AgreementsResponse };
        return response.data;
    },

    // Update subcontractor agreements
    updateSubcontractorAgreements: async (subcontractorId: string, data: AgreementsRequest): Promise<AgreementsResponse> => {
        const response = await apiClient.put(`/subcontractors/${subcontractorId}/agreements`, data) as { data: AgreementsResponse };
        return response.data;
    },

    // Get user's IP address (helper function)
    getUserIpAddress: async (): Promise<string> => {
        try {
            // Try to get IP from a public API
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return data.ip;
        } catch (error) {
            console.warn('Failed to get IP address:', error);
            // Fallback IP
            return '0.0.0.0';
        }
    }
};
